export default [
  {
    path: "/guestbook-test",
    name: "guestbookTest",
    component: () => import("@/views/internal/GuestbookTestPage.vue"),
    meta: {
      rights: ["g_intern"],
      navbarTitle: "Gästebuch-Test",
      hideBottomNavigation: true,
      fullWidth: true,
    },
  },
]
